const FileRenderer = ({ fileUrl }) => {
  const getFileType = (url) => {
    const fileExtension = url.split(".").pop().toLowerCase();

    switch (fileExtension) {
      case "pdf":
        return "pdf";
      case "pptx":
        return "pptx";
      default:
        return "unknown";
    }
  };

  const fileType = getFileType(fileUrl);

  return (
    <div className="mt-5 mb-5">
      {fileType === "pdf" && (
        <object
          key={fileUrl}
          data={fileUrl}
          type="application/pdf"
          width="100%"
          height="1000px"
        >
          <p>
            Your browser does not support PDFs.{" "}
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              Download the PDF
            </a>
            .
          </p>
        </object>
      )}

      {fileType === "pptx" && (
        <iframe
          key={fileUrl}
          title="PowerPoint Viewer"
          width="100%"
          height="1000px"
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            fileUrl
          )}`}
          frameBorder="0"
        ></iframe>
      )}
    </div>
  );
};

export default FileRenderer;
